import { render, staticRenderFns } from "./InputOtp.vue?vue&type=template&id=9b5119dc&scoped=true"
import script from "./InputOtp.vue?vue&type=script&lang=js"
export * from "./InputOtp.vue?vue&type=script&lang=js"
import style0 from "./InputOtp.vue?vue&type=style&index=0&id=9b5119dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5119dc",
  null
  
)

export default component.exports